export const PERSONALIZATION_MODAL_KEY = 'personalization';
